import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M8.00016 10.1666C8.25329 10.1666 8.46249 10.3547 8.4956 10.5988L8.50016 10.6666V11.3333C8.50016 11.6095 8.27631 11.8333 8.00016 11.8333C7.74703 11.8333 7.53784 11.6452 7.50473 11.4012L7.50016 11.3333V10.6666C7.50016 10.3905 7.72402 10.1666 8.00016 10.1666Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M8.4956 4.5988C8.46249 4.35475 8.25329 4.16665 8.00016 4.16665C7.72402 4.16665 7.50016 4.3905 7.50016 4.66665V8.66665L7.50473 8.73449C7.53784 8.97854 7.74703 9.16665 8.00016 9.16665C8.27631 9.16665 8.50016 8.94279 8.50016 8.66665V4.66665L8.4956 4.5988Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M14.6668 7.99998C14.6668 4.31808 11.6821 1.33331 8.00016 1.33331C4.31826 1.33331 1.3335 4.31808 1.3335 7.99998C1.3335 11.6819 4.31826 14.6666 8.00016 14.6666C11.6821 14.6666 14.6668 11.6819 14.6668 7.99998ZM2.3335 7.99998C2.3335 4.87037 4.87055 2.33331 8.00016 2.33331C11.1298 2.33331 13.6668 4.87037 13.6668 7.99998C13.6668 11.1296 11.1298 13.6666 8.00016 13.6666C4.87055 13.6666 2.3335 11.1296 2.3335 7.99998Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }